export class SingleResetEvent {
    isSignaled = false;
    toResolve;
    constructor() {
        this.toResolve = null;
    }
    set() {
        this.isSignaled = true;
        if (this.toResolve) {
            this.toResolve();
        }
    }
    async wait() {
        if (this.isSignaled) {
            return Promise.resolve();
        }
        return new Promise(resolve => {
            this.toResolve = resolve;
        });
    }
}
